// extracted by mini-css-extract-plugin
export default {"auth_overlay":"Auth_auth_overlay__ayX0+","center":"Auth_center__8w3Ot","authBtn":"Auth_authBtn__mWrVZ","error_msg":"Auth_error_msg__4JOQ-"};